import { editingCategorySelector } from "./editingCategorySelector";
import { RootState } from "../../../../store";

export const editingCategoryNameSelector = (state: RootState) => {
  const editingCategory = editingCategorySelector(state);

  return editingCategory?.name;
};
